import { getCookie, hasWindow, setCookie } from "@litres/utils";

/**
 * @description Метод формирует и возвращает url изображения аватара юзера
 * Принимает userID как обязательный параметр
 */
export const getLibraryLogoImageURL = (libraryID: number): string => {
  const path = `${"000000000000".substr(
    0,
    12 - libraryID.toString().length
  )}${libraryID}`;
  const fullPath = `https://www.litres.ru/static/ds/img/librarylogo/1${path.substr(
    0,
    2
  )}/${path.substr(2, 2)}/${path.substr(4, 2)}/${path.substr(
    6,
    2
  )}/${path.substr(8, 2)}/${libraryID}.png`;
  return fullPath;
};

/**
 * @description Метод формирует и возвращает url изображения аватара автора
 * Принимает authorID как обязательный параметр
 */
export const getAuthorImageURL = (authorID: number): string => {
  const path = `${"000000000000".substr(
    0,
    10 - authorID.toString().length
  )}${authorID}`;

  return `https://cdn.litres.ru/pub/authors/1${path.substr(
    0,
    2
  )}/${path.substr(2, 2)}/${path.substr(4, 2)}/${path.substr(
    6,
    2
  )}/${"00000000".substr(
    0,
    8 - authorID.toString().length
  )}${authorID}_100.jpg`;
};

/**
 * @description Метод формирует и возвращает url изображения книги для поиска
 * Принимает bookID как обязательный параметр
 */
export const getBookImageURL = (bookID: number): string => {
  return `https://cdn.litres.ru/pub/c/cover_30/${bookID}.jpg`;
};

/**
 * Функция которая принимает массив и делит его на части размером второго параметра.
 *
 * @param {any[]} arr - Массив любых типов
 * @param {number} size - Количество элементов при достижении которого массив будет делиться
 * @return {any[][]} Массив массивов разделенных по параметру size
 *
 * @example
 *
 *     splitArrayOnChunks(["Один", "Два, "Три"], 1)
 *     // [[Один], [Два], [Три]]
 */
export const splitArrayOnChunks = (arr: any[], size: number): any[][] => {
  return arr.reduce(
    (acc, e, i) => (
      i % size ? acc[acc.length - 1].push(e) : acc.push([e]), acc
    ),
    []
  );
};

/**
 * @deprecated
 */
export const getPublishingLogo = (id: number, logoFormat: string): string => {
  return `https://litres.ru/static/copyrights_logo/${id}_640.${logoFormat}`;
};

/**
 * Функция склеивающая домен с целевым path
 *
 * @param {string} path - путь к ресурсу, начинающийся с "/"
 * @returns {string}
 */
export const getAbsoluteUrl = (path: string): string =>
  `https://litres.ru${path}`;

/**
 * @description Функция возвращающая boolean в случае если текущая дата находится в заданном промежутке дат
 *
 * @param startDate - дата в формате "2022-07-13" {string} или тайм штамп в формате {number}
 * @param endDate - дата в формате "2022-07-15" {string} или тайм штамп в формате {number}
 *
 * @return true если дата попадает в заданный интервал
 * @example
 *    isTimeToPromotion("2022-07-13", "2022-07-15")
 *          // true
 */
export const isTimeToPromotion = (
  startDate: string | number,
  endDate: string | number
): boolean => {
  const now = Date.now();
  const TIME_PATTERN = "T00:00:00.0003";
  const start =
    typeof startDate === "number"
      ? startDate
      : Date.parse(`${startDate}${TIME_PATTERN}`);
  const end =
    typeof endDate === "number"
      ? endDate
      : Date.parse(`${endDate}${TIME_PATTERN}`);

  return start < now && now < end;
};

/*
 * Приведение типа
 */
export const toDate = (date: string | Date | number | undefined): Date => {
  if (date === undefined || date === 0) {
    return new Date(0);
  }

  if (date instanceof Date) {
    return date;
  }

  if (typeof date === "number") {
    return new Date(date * 1000);
  }

  return new Date(date);
};

export const hideNewHeaderForLibrarian = (
  is_librarian: boolean,
  isAnon: boolean,
  lang?: string
) => {
  // прячем новую шапку для библиотекарей
  if (
    is_librarian &&
    hasWindow &&
    (getCookie("next_genre") === "1" || getCookie("next_author") === "1")
  ) {
    getCookie("next_genre") === "1" &&
      setCookie("next_genre", "0", {
        expires: new Date(Date.now() + 864000000).toUTCString(), // 10 дней
      });
    getCookie("next_author") === "1" &&
      setCookie("next_author", "0", {
        expires: new Date(Date.now() + 864000000).toUTCString(), // 10 дней
      });
    window.location?.reload();
  }

  // если библиотекарь разлогинился, снова ставим новую шапку
  if (isAnon) {
    getCookie("next_genre") === "0" &&
      lang === "ru" &&
      setCookie("next_genre", "1", {
        expires: new Date(Date.now() + 864000000).toUTCString(), // 10 дней
      });
    getCookie("next_author") === "0" &&
      setCookie("next_author", "1", {
        expires: new Date(Date.now() + 864000000).toUTCString(), // 10 дней
      });
  }
};
